<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7280_63342)">
      <path
        d="M5.48047 5.35156C5.8035 5.35156 6.06641 5.08865 6.06641 4.76562C6.06641 4.4426 5.8035 4.17969 5.48047 4.17969C5.15729 4.17969 4.89453 4.4426 4.89453 4.76562C4.89453 5.08865 5.15729 5.35156 5.48047 5.35156Z"
        fill="#8B90A4"
      />
      <path
        d="M5.48102 6.91406C4.56152 6.91406 3.78928 7.5322 3.58984 8.35938H7.37204C7.17261 7.53235 6.40036 6.91406 5.48102 6.91406Z"
        fill="#8B90A4"
      />
      <path
        d="M19.4141 0.195312H0.585938C0.262299 0.195312 0 0.457611 0 0.78125V12.3438H20V0.78125C20 0.457611 19.7377 0.195312 19.4141 0.195312ZM8.59375 8.94531C8.59375 9.26895 8.33145 9.53125 8.00781 9.53125H2.95364C2.63 9.53125 2.36771 9.26895 2.36771 8.94531V8.78174C2.36771 7.53998 3.13461 6.47049 4.22989 5.99915C3.91663 5.68161 3.72284 5.24582 3.72284 4.76562C3.72284 3.79639 4.51141 3.00781 5.48065 3.00781C6.44989 3.00781 7.23846 3.79639 7.23846 4.76562C7.23846 5.24582 7.04468 5.68161 6.73141 5.99915C7.82684 6.47049 8.59375 7.53998 8.59375 8.78174V8.94531ZM14.3753 9.06418H10.3516C10.0279 9.06418 9.76562 8.80173 9.76562 8.47824C9.76562 8.1546 10.0279 7.8923 10.3516 7.8923H14.3753C14.6989 7.8923 14.9612 8.1546 14.9612 8.47824C14.9612 8.80173 14.6989 9.06418 14.3753 9.06418ZM14.3753 6.72043H10.3516C10.0279 6.72043 9.76562 6.45798 9.76562 6.13449C9.76562 5.81085 10.0279 5.54855 10.3516 5.54855H14.3753C14.6989 5.54855 14.9612 5.81085 14.9612 6.13449C14.9612 6.45798 14.6989 6.72043 14.3753 6.72043ZM17.0703 4.37668H10.3516C10.0279 4.37668 9.76562 4.11423 9.76562 3.79074C9.76562 3.4671 10.0279 3.2048 10.3516 3.2048H17.0703C17.394 3.2048 17.6562 3.4671 17.6562 3.79074C17.6562 4.11423 17.394 4.37668 17.0703 4.37668Z"
        fill="#8B90A4"
      />
      <path
        d="M0 15.2734C0 15.5971 0.262299 15.8594 0.585938 15.8594H19.4141C19.7377 15.8594 20 15.5971 20 15.2734V13.5156H0V15.2734Z"
        fill="#8B90A4"
      />
      <path
        d="M14.6875 18.6328H13.5156V17.0312H6.48438V18.6328H5.3125C4.98886 18.6328 4.72656 18.8951 4.72656 19.2188C4.72656 19.5424 4.98886 19.8047 5.3125 19.8047H14.6875C15.0111 19.8047 15.2734 19.5424 15.2734 19.2188C15.2734 18.8951 15.0111 18.6328 14.6875 18.6328Z"
        fill="#8B90A4"
      />
    </g>
    <defs>
      <clipPath id="clip0_7280_63342">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
